import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

//---helpers
import { CATALOG_PRODUCTS_TYPE, PRODUCTS_ORDER_KEY } from '@/helpers';
import { globalLoader, pluralizate } from '@/helpers/variables';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import ProductsBlock from '@/components/products/ProductsBlock/index.vue';
import Pagination from '@/components/@general/Pagination/index.vue';
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';

export default {
  name: 'CatalogTag',
  mixins: [dynamicHead],
  components: {
    BreadcrumbsSimple,
    ProductsBlock,
    Pagination
  },
  data() {
    return {
      PRODUCTS_ORDER_KEY,
      catalogTag: null,
      catalogTagData: null,
      catalogTagProducts: [],
      catalogTagMeta: null,
      isCatalogTagLoading: false
    };
  },
  created() {
    let { category } = this.$route.params;
    this.catalogTag = category;
    this._loadContent();
  },
  watch: {
    $route: {
      immediate: false,
      handler(newVal) {
        if (newVal) {
          this._getProducts();
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      favourites: 'favorites/whichList'
    }),
    breadcrumbs() {
      return [{ title: this.$t('catalog'), route: { name: 'products' } }];
    },
    catalogTagTitle() {
      let { title, parent } = this.catalogTagData;
      if (parent && parent.data.title) {
        title = `${parent.data.title}: ${title}`;
      }

      return title;
    },
    titlePluralizate() {
      return pluralizate(
        this.catalogTagMeta ? this.catalogTagMeta.total : 0,
        this.$t('label.products.countOne'),
        this.$t('label.products.countSimple'),
        this.$t('label.products.countMany')
      );
    },
    productsList() {
      if (!this.isAuthenticated || !this.favourites) {
        return this.catalogTagProducts;
      }

      const favourites = _.map(this.favourites, 'productId');
      const markAsSelected = (product) => {
        product.isFavorite = favourites.includes(product.id);
        return product;
      };

      return _.map(this.catalogTagProducts, markAsSelected);
    }
  },
  methods: {
    ...mapActions({
      getCatalogProducts: 'catalog/GET_CATALOG_PRODUCTS',
      getCatalogAttribute: 'catalog/GET_CATALOG_ATTRIBUTE'
    }),
    _getProducts() {
      this.isCatalogTagLoading = true;
      let { params: routeParams, query } = this.$route;
      let { page, tag } = routeParams;
      let { orderby } = query;

      let sortFilterType = orderby
        ? orderby
        : this.catalogTag === CATALOG_PRODUCTS_TYPE.NEWEST
          ? PRODUCTS_ORDER_KEY.NEWEST
          : PRODUCTS_ORDER_KEY.BESTSELLERS;

      return this.getCatalogProducts({
        attribute: tag,
        page: page ? Number(page) : 1,
        sort_filter_type: sortFilterType
      })
        .then((result) => {
          this.catalogTagProducts = result.data;
          this.catalogTagMeta = result.meta;
        })
        .finally(() => {
          this.isCatalogTagLoading = false;
        });
    },
    async _loadContent() {
      globalLoader(true);
      let promiseCollection = [];
      let { tag } = this.$route.params;
      promiseCollection.push(
        this.getCatalogAttribute(tag).then((result) => {
          this.catalogTagData = result.data;
          this._setMetaParams();
        })
      );
      promiseCollection.push(this._getProducts());
      await Promise.all(promiseCollection);

      globalLoader(false);
    },

    _setMetaParams() {
      let { title, metaTitle, metaDescription, image } = this.catalogTagData;

      this.metaParams.title = `${metaTitle || title} ${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = metaDescription || `${metaTitle || title} ${this.$t('seo.metaDescGeneral')}`;
      this.metaParams.image = image || null;
      this.setMeta();
    }
  }
};
